import * as angular from "angular";
import {IController, IIntervalService, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {LeanPlanningService} from "../../services/lean-planning-service.service";

export class planningDispatchRoutesLoadingView implements IController {
  from: any;
  to: any;
  statuses: any;
  branchIds: any;
  resourceIds: any;

  private siteId: any;
  private routes: any;
  private routesRefList: any;
  private filterConfig: any;
  private viewSettings: any;
  private size: any;
  private page: any;

  private paginationPages: any;
  private routesServiceAreas: any;
  private selectedRouteIds: any;
  private hiddenRouteIds: any;

  private routesInterval: number;
  private routeColumnInterval: number;
  private intervalRef: any;
  private intervalFromDate: any;

  constructor(private leanPlanningService: LeanPlanningService, private moment, private $planningRoutes, private $route,
              private $scope: IScope, private splitService: SplitService, private $state,
              private $interval: IIntervalService, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.routesInterval = 10000;
    this.routeColumnInterval = 3000;

    this.siteId = this.splitService.getSiteId();
    this.routesServiceAreas = [];
    this.selectedRouteIds = [];
    this.hiddenRouteIds = [];

    this.filterConfig = {
      range: {
        dateStart: this.from || this.moment().startOf('day').valueOf(),
        dateEnd: this.to || this.moment().endOf('day').valueOf()
      },
      statuses: this.statuses || [],
      branchIds: this.branchIds || [],
      resourceIds: this.resourceIds || []
    }
    this.viewSettings = this.splitService.getRoutesLoadingSettings(this.siteId);

    this.routes = undefined; // Loading On when undefined
    this.routesRefList = [];

    this.size = 5;
    this.page = 0;


    this._initRoutes();
  };

  $onDestroy() {
    if (this.routesRefList.length) {
      this._destroyRoutesBindings();
    }

    this._destroyInterval();
  };

  // ******************************
  //        Public methods
  // ******************************

  onViewSettingsChange(settings) {
    this.viewSettings = settings;
    this.splitService.setRoutesLoadingSettings(settings, this.siteId);
  }

  onFiltersChange(range, branchIds, resourceIds, statuses) {
    this.filterConfig.range = range;
    this.filterConfig.branchIds = branchIds;
    this.filterConfig.resourceIds = resourceIds;
    this.filterConfig.statuses = statuses;

    this._initRoutes();
    this._setStateParams();
  }

  isPaginationItemSelected(pageIndex) {
    return _.get(this.routes, 'pageable.pageNumber') === pageIndex;
  }

  onPaginationBrowse(isNext) {
    this.page = isNext ? (this.routes.last ? 0 : this.page + 1) : (this.routes.first ? (this.routes.totalPages - 1) : this.page - 1);
    this._initRoutes();
  }

  onDateRangeBrowse(isNext) {
    this.filterConfig.range = {
      dateStart: isNext ? this.moment(this.filterConfig.range.dateStart).add(1, 'days').valueOf() : this.moment(this.filterConfig.range.dateStart).subtract(1, 'days').valueOf(),
      dateEnd: isNext ? this.moment(this.filterConfig.range.dateEnd).add(1, 'days').valueOf() : this.moment(this.filterConfig.range.dateEnd).subtract(1, 'days').valueOf()
    }
    this._initRoutes();
    this._setStateParams();
  }

  onPaginationChange(pageIndex) {
    this.page = pageIndex;
    this._initRoutes();
  }
  onTimeCycleDone(){
    this.onPaginationBrowse(true);

    const routeAutomationTimeRef = angular.copy(this.viewSettings.routesAutomationTime);
    this.viewSettings.routesAutomationTime = undefined;
    this.$timeout(0).then(()=>{
      this.viewSettings.routesAutomationTime = routeAutomationTimeRef;
    });

  }


  // ******************************
  //        Private methods
  // ******************************

  private _initRoutes(addTimeOut?) {

    this._destroyInterval();

    const queryPayload = {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      status: this.filterConfig.statuses,
      allocationIds: this.filterConfig.resourceIds,
      size: this.size,
      page: this.page
    };

    // this.routes = [];
    // this.paginationPages = undefined;

    this.leanPlanningService.getPageableRoutes(queryPayload, addTimeOut)
      .then((routes: any) => {
        this.routes = routes;
        this.hiddenRouteIds = _.map(routes.content, 'id');
        this.paginationPages = _.range(routes.totalPages);

        // this._setServiceAreaIds(routes.content);
        this._bindRoutes(routes.content);
      })
  }

  private _bindRoutes(routes) {

    if (this.routesRefList.length) {
      this._destroyRoutesBindings();
    }

    this.routesRefList = [];

    if (routes && routes.length) {
      const routeIds = _.map(routes, 'id');

      _.forEach(routeIds, (id) => {
        const routeRef = this.$planningRoutes(id);
        this.routesRefList.push(routeRef);

        routeRef.$bindCtrl(this.$scope, this, id);
        routeRef.$registerOnUpdateHandler(this, (updatedRoute) => {

          if (_.isEqual(updatedRoute.id, id)) {
            const routeIndexToUpdate = _.findIndex(this.routes.content, (i: any) => {
              return i.id === updatedRoute.id;
            });
            if (routeIndexToUpdate &&
              !_.isEqual(this.routes.content[routeIndexToUpdate].serviceIdList, updatedRoute.serviceIdList)) {

              this.$route(id).$get()
                .then((r) => {
                  // const routesCopy = angular.copy(this.routes);
                  // routesCopy.content[routeIndexToUpdate] = r;
                  //
                  // this.routes = routesCopy;

                  this.routes.content[routeIndexToUpdate] = r;
                })

            }
          }
        });

        // routeRef.$registerOnUpdateHandler(this, (updatedRoute) => {
        //
        //   if (_.isEqual(updatedRoute.id, id)) {
        //     const routeIndexToUpdate = _.findIndex(this.routes.content, (i: any) => {
        //       return i.id === updatedRoute.id;
        //     });
        //     if (routeIndexToUpdate > -1) {
        //       let routeToUpdateRef = this.routes.content[routeIndexToUpdate];
        //
        //       if (updatedRoute.updatedAt > routeToUpdateRef.updatedAt) {
        //         let routesCopy = angular.copy(this.routes.content);
        //         updatedRoute.taskListExt = routeToUpdateRef.taskListExt; // TODO REMOVE ITS A WORK A ROUND FOR NO TASKS
        //         routesCopy[routeIndexToUpdate] = updatedRoute;
        //
        //         this.routes.content = routesCopy;
        //       }
        //
        //     }
        //   }
        // });
      })

    }
  }

  private _destroyRoutesBindings() {
    _.forEach(this.routesRefList, (routeObjectRef) => {
      routeObjectRef.$destroy();
    });
  }

  private _setStateParams() {
    this.$state.go('.', {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.branchIds,
      resourceIds: this.filterConfig.resourceIds,
      statuses: this.filterConfig.statuses,
    }, {notify: false, reload: false});
  }

  private _destroyInterval() {
    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
      this.intervalRef = undefined;
      this.intervalFromDate = undefined;
    }
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningDispatchRoutesLoadingView', {
    bindings: {
      from: '<?',
      to: '<?',
      statuses: '<?',
      branchIds: '<?',
      resourceIds: '<?'
    },
    template: require('./planning-dispatch-routes-loading-view.html').default,
    controller: planningDispatchRoutesLoadingView
  });
